module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_tokyo-e8494a018217208dc2bdf47988542f63.png";